// Crew-styled create/edit department modal - Tailwind overlay + card
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { X } from 'lucide-react';

import { ErrorToast } from 'components';
import DepartmentService from 'api/department';
import DepartmentManagementForm from '../features/departmentManagement/DepartmentManagement_Form';

const CrewDepartmentModal = ({ toggleModal, isModalToggled, fetchData, editDept }) => {
  const [isSaving, setIsSaving] = useState(false);

  const onSubmit = async (payload) => {
    const fPayload = formatPayload(payload);
    if (editDept) return updateDepartment(fPayload);
    createDepartment(fPayload);
  };

  const formatPayload = (payload) => {
    const clientId = localStorage.getItem('BR_CLIENT_ID');
    return { clientId, name: payload.name, tags: payload.tag ? [payload.tag] : [] };
  };

  const createDepartment = async (fPayload) => {
    try {
      setIsSaving(true);
      await DepartmentService.create(fPayload);
      await fetchData();
      setIsSaving(false);
      toggleModal(false);
    } catch (error) {
      setIsSaving(false);
      toast.error(<ErrorToast error={error} />);
    }
  };

  const updateDepartment = async (fPayload) => {
    try {
      setIsSaving(true);
      await DepartmentService.update(editDept._id, fPayload);
      await fetchData();
      setIsSaving(false);
      toggleModal(false);
    } catch (error) {
      setIsSaving(false);
      toast.error(<ErrorToast error={error} />);
    }
  };

  if (!isModalToggled) return null;

  return (
    <div className="tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-center tw-justify-center">
      <div className="tw-fixed tw-inset-0 tw-bg-black/50" onClick={() => toggleModal(false)} />
      <div className="tw-relative tw-bg-white tw-rounded-xl tw-shadow-xl tw-w-full tw-max-w-md tw-mx-4 tw-max-h-[85vh] tw-overflow-y-auto">
        {/* Header */}
        <div className="tw-flex tw-items-center tw-justify-between tw-p-6 tw-border-b tw-border-gray-200">
          <h2 className="tw-text-lg tw-font-semibold tw-text-gray-900 tw-m-0">
            {editDept ? 'Edit department' : 'Create new department'}
          </h2>
          <button
            onClick={() => toggleModal(false)}
            className="tw-p-1 tw-rounded tw-border-0 tw-bg-transparent tw-cursor-pointer hover:tw-bg-gray-100"
          >
            <X className="tw-w-5 tw-h-5 tw-text-gray-500" />
          </button>
        </div>
        {/* Body */}
        <div className="tw-p-6">
          <DepartmentManagementForm onSubmit={onSubmit} isLoading={isSaving} editDept={editDept} />
        </div>
      </div>
    </div>
  );
};

export default CrewDepartmentModal;
